import { ActionButton, Paginator, TableComponent } from 'components'
import { Payment_status, status_type } from '_graphql/__generated__/globalTypes-kek'
import { useAppNavigate, useAppSearch } from '_graphql/cache/auth'

import { Action } from 'components/buttons/action-button'
import ApproveTreatyContainer from './approve'
import { TreatyType } from '_graphql/__generated__/globalTypes'
import ViewTreatyDocumentsContainer from './view-slip'
import { useKEKTreaties } from 'hooks/data/use-treaties'
import { usePagination } from 'hooks'
import { useUrlState } from 'utils'

type Props = {}

const UnapprovedTreaties = (props: Props) => {
    const searchParams = useAppSearch();
    const [modal, setModal] = useUrlState("modal");
    const { limit, offset, search, setPage } = usePagination();
    const navigate = useAppNavigate()
    const { treaties, loading, refetch, count } = useKEKTreaties({
        args: {
            approval_status: status_type.UNAPPROVED,
            limit: limit,
            offset: offset,
            search: search
        }
    })

    const navigateItem =
        (id: string, layers: string, treaty_type: string) => () => {
            navigate({
                to: `./${id}/view`,
                search: (old) => ({
                    ...old,
                    // layers: layers,
                    layer: "1",
                    treaty_type: treaty_type,
                }),
            });
        };

    const dispatchAction =
        (id: string, action: Exclude<Action, "expand" | "goto" | "clone">) =>
            () => {
                navigate({
                    search: (old) => ({
                        ...old,
                        id,
                        modal: action,
                    }),
                });
            };

    return (
        <>
            <TableComponent
                title={"Unapproved treaties"}
                columns={[
                    {
                        name: "Ref#",
                        accessor: "treaty_reference",
                    },
                    {
                        name: "Insurer",
                        accessor: "insurer.insurer_company_name",
                    },
                    {
                        name: "Treaty Program",
                        accessor: "treaty_program.treaty_name",
                    },
                    {
                        name: "Program Type",
                        accessor: "treaty_program.treaty_type",
                    },
                    {
                        name: "Created By",
                        accessor: "employee.employee_first_name",
                        render: (value) => (
                            <div className="flex flex-row leading-0">
                                <span>
                                    {value?.employee?.employee_first_name}{" "}
                                    {value?.employee?.employee_last_name}
                                </span>
                            </div>
                        ),
                    },
                    {
                        name: "Period",
                        accessor: "treaty_deduction",
                        render: (value) => (
                            <div className="flex leading-0">
                                <span>
                                    {value?.treaty_deduction?.treaty_period_from} to{" "}
                                    {value?.treaty_deduction?.treaty_period_to}
                                </span>
                            </div>
                        ),
                    },
                    {
                        name: "Currency",
                        accessor: "currency",
                        // render: (value) => {
                        //     const currency = value?.treaty_program?.treaty_type === TreatyType.NONPROPORTIONAL ? value?.currency : JSON.parse(value?.treaty_details ?? "[]")?.find(
                        //         (el: any) => el.keydetail.toLowerCase() === "currency"
                        //     )?.value;

                        //     return currency || "N/A";
                        // }
                    },
                    {
                        name: "Payment Status",
                        accessor: "treaty_payment_status",
                        render: (value) => (
                            <div className="flex leading-0">
                                <span
                                    className={`px-2 py-1 text-xs capitalize font-semibold rounded-full ${value?.treaty_payment_status === Payment_status.PAID
                                        ? "bg-green-100 text-green-800"
                                        : value?.treaty_payment_status ===
                                            Payment_status.UNPAID
                                            ? "bg-red-100 text-red-800"
                                            : "bg-yellow-100 text-yellow-800"
                                        }`}
                                >
                                    {value?.treaty_payment_status?.toLowerCase()}
                                </span>
                            </div>
                        ),
                    },
                    {
                        name: "Actions",
                        accessor: "actions",
                        render: (value) => (
                            <>
                                <ActionButton action={'clone'} tooltip='View Documents' onClick={dispatchAction(value?.treaty_id || "", "view")} />
                                <ActionButton action={'thumbs-up'} tooltip='Approve Treaty' onClick={dispatchAction(value?.treaty_id || "", "accept")} />
                                <ActionButton
                                    action={"expand"}
                                    tooltip="View Treaty"
                                    onClick={navigateItem(
                                        value?.treaty_id || "",
                                        value?.layer_limit as string,
                                        value?.treaty_program?.treaty_type as string
                                    )}
                                />


                            </>
                        ),
                    },
                ]}
                loading={loading}
                data={treaties}
                refetch={refetch}
                pagination={() => <Paginator totalItems={count} currentSize={treaties.length} offset={offset} limit={limit} setOffset={setPage} />}
            />

            {searchParams?.id && modal === "accept" && (
                <ApproveTreatyContainer
                    open={modal === "accept"}
                    setOpen={(val: boolean) => setModal(val ? "accept" : undefined)}
                />
            )}
            {searchParams?.id && modal === "view" && (
                <ViewTreatyDocumentsContainer
                    open={modal === "view"}
                    setOpen={(val: boolean) => setModal(val ? "view" : undefined)}
                />
            )}
        </>
    )
}

export default UnapprovedTreaties